<template>
    <v-data-table
        :headers="filteredHeaders"
        :items="items"
        :options="options"
        :items-per-page="-1"
        hide-default-footer
        class="border-bottom"
        test-id="data-table"
        :class="[rowClickable ? 'row-clickable' : '']"
        :header-props="{ sortIcon: 'mdi-menu-up' }"
        @click:row="$emit('click:row', $event)"
        @update:options="$emit('update:options', $event)"
    >
        <template v-if="loading" v-slot:body>
            <tr v-for="(i, index) in 1" :key="index">
                <td v-for="header in filteredHeaders" :key="header.value">
                    <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
            </tr>
        </template>
        <template v-slot:item="{ item, index }">
            <v-hover v-slot:default="{ hover }">
                <tr v-show="!loading" @click="$emit('click:row', item); $emit('click:row-index', index)">
                    <td v-for="(column, columnIndex) in filteredHeaders" :key="columnIndex">
                        <slot :name="getItemSlotName(column.value)" :item="item">
                            <icon-button
                                v-if="column.value === 'edit'"
                                v-show="hover"
                            >
                                edit
                            </icon-button>
                            <action-menu
                                v-else-if="column.value === 'actionMenu'"
                                :items="actionMenu.actions"
                                @action="actionMenu.actions[$event].action(item)"
                            />
                            <div v-else>
                                {{ get(item, column.value) }}
                            </div>
                        </slot>
                    </td>
                </tr>
            </v-hover>
        </template>
    </v-data-table>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "DataTable",
    props: {
        headers: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        rowClickable: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const getItemSlotName = (name) => {
            return `item.${name}`
        }

        const itemSlots = computed(() => props.headers.map(x => x.value).filter(x => ctx.slots[getItemSlotName(x)]))
        const actionMenu = computed(() => props.headers.find(x => x.value === 'actionMenu'))
        const filteredHeaders = computed(() => {
            let headers = props.headers

            let editIndex = headers.findIndex(x => x.value === 'edit')
            if (editIndex >= 0) {
                headers[editIndex].sortable = false
                headers[editIndex].width = 53
            }

            let actionMenuIndex = headers.findIndex(x => x.value === 'actionMenu')
            if (actionMenuIndex >= 0) {
                headers[actionMenuIndex].sortable = false
                headers[actionMenuIndex].width = 53
            }

            return headers
        })

        return {
            getItemSlotName,
            itemSlots,
            actionMenu,
            filteredHeaders
        }
    }
}
</script>

<style scoped lang="scss">
.v-data-table {
    &.row-clickable {
         ::v-deep table {
            tbody {
                tr {
                    cursor: pointer;
                }
            }
        }
    }

    ::v-deep thead {
        tr {
            th {
                opacity: 0.6 !important;
                font-weight: 500 !important;
                white-space: nowrap;

                &:last-child {
                    padding-right: 0 !important;
                }
            }
        }
    }

    &:not(.row-clickable) {
        tr {
            &:hover {
                background: unset !important;
            }
        }
    }

    ::v-deep tbody {
        tr {
            td {
                &:last-child {
                    padding-right: 0 !important;
                }
            }
        }
    }
}
</style>